import React from 'react';
import { Spinner } from 'react-bootstrap';

const AppSpinner = ({
    animation = "border",
    variant = "danger",
    size = "sm",
    showText = true,
    text = "Loading...",
    className = "",
}) => {
    return (
        <React.Fragment>
            {showText ? (
                <div className={`d-flex align-items-center ${className}`}>
                    <Spinner
                        animation={animation}
                        variant={variant}
                        size={size}
                        className="me-1"
                    />
                    <span className={`text-${variant}`}>{text}</span>
                </div>
            ) : (
                <Spinner
                    animation={animation}
                    variant={variant}
                    size={size}
                />
            )}
        </React.Fragment>
    );
};

export default AppSpinner;